import {Injectable} from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class InputStore {

}

export enum InputStoreKeys {

}
